module.exports = __webpack_public_path__ + "fonts/fa-light-300.fcf1da7.woff";